// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
let RECAPTCHA_SITE_KEY = "6Ld8Z_8pAAAAAEZrSxg4gTPpvNW-1aETv55aQkH7";
let TOKEN = "eyJ4NXQiOiJNell4TW1Ga09HWXdNV0kwWldObU5EY3hOR1l3WW1NNFpUQTNNV0kyTkRBelpHUXpOR00wWkdSbE5qSmtPREZrWkRSaU9URmtNV0ZoTXpVMlpHVmxOZyIsImtpZCI6Ik16WXhNbUZrT0dZd01XSTBaV05tTkRjeE5HWXdZbU00WlRBM01XSTJOREF6WkdRek5HTTBaR1JsTmpKa09ERmtaRFJpT1RGa01XRmhNelUyWkdWbE5nX1JTMjU2IiwiYWxnIjoiUlMyNTYifQ.eyJzdWIiOiJhZG1pbiIsImF1dCI6IkFQUExJQ0FUSU9OIiwiYXVkIjoiNmhNMF9DVDFxSjZPMGhsUnJKNXNubGs3azA4YSIsIm5iZiI6MTcyMjYwMzE4NSwiYXpwIjoiNmhNMF9DVDFxSjZPMGhsUnJKNXNubGs3azA4YSIsInNjb3BlIjoiZGVmYXVsdCIsImlzcyI6Imh0dHBzOlwvXC9hcGktdGVzdC5waW9uZWVyLmNvbS5waDo5NDQzXC9vYXV0aDJcL3Rva2VuIiwiZXhwIjo5MjIzMzcyMDM2ODU0Nzc1LCJpYXQiOjE3MjI2MDMxODUsImp0aSI6ImVmNzUyOWY5LWJkMGYtNGRkNy1hNjhkLTEzYzA3YzE3N2JkMyJ9.ChtJqMPm32i-cI9RsrvuBhCh358dS37Uipxf1m1inOfySipbaI4kmIZzjiOZF4ymSZttwKfE1zxa0lEk3umk47TDGo_d0FMn7IO2D9lIS6W4UnXwulO4ODz2E4S4p3apD_mRHOiSUYEc2wafV1pYKEk8MQBb2-GPZ_BSSmQhUxkkGR1eNrxxsTaNSuz5le-CGqmC-mczT9TKHuJddb5CUpYD6FjE5J2ABHIdAnX-ikutoG2GhmKH6ki9Vwhu41vbnxbVZb6tvlLLGTQO0j-N1nyCd4DBmDXJNYpANach2ejR1gRf3TQ3B7mtVmHMtYaIOlv5ajwW0MzY9b2M80bYIQ";
let defaultISSPrefix = "ISSP";
 
// CTPL FAQS
let ctplDocs = "https://dev.pioneerinsureshop.com/api/v1/admin/file/download/CTPL_FAQ.pdf";
 
let keycloakConfig = {
  clientId: 'insureshop-app',
  realm: 'insureshop',
  url: 'https://keycloak.pioneerinsureshop.com/auth',
  credentials: {
    secret: '5d9dc648-7067-4268-b902-b58520f6b711'
  }
}
 
let externalAppConfig = {
  url: 'https://accihealth-ui.test.service.pioneerinsureshop.com',
  motorProducts: 'https://accihealth-ui.test.service.pioneerinsureshop.com/motor/products'
}
 
let accihealthConfig = {
  url: 'https://accihealth-core.test.service.pioneerinsureshop.com',
  hospicash: 'https://accihealth-ui.test.service.pioneerinsureshop.com/product/hospicash',
  ooopsie: 'https://accihealth-ui.test.service.pioneerinsureshop.com/product/ooopsie'
}
 
let ctplConfig = {
  url: 'https://ctpl-core.test.service.pioneerinsureshop.com',
  ctpl: 'https://accihealth-ui.test.service.pioneerinsureshop.com/motor/ctpl',
  motorProducts: 'https://pnr-uat-clienthub.insureshop.ph/public/static-journey/lob-products',
  ctplProduct: 'https://pnr-uat-clienthub.insureshop.ph/public/static-journey/lob-products?cat=ctpl',
  motorcycle: 'https://pnr-uat-clienthub.insureshop.ph/public/static-journey/lob-products?cat=ridesure',
  motorCar: 'https://pnr-uat-clienthub.insureshop.ph/public/static-journey/lob-products?cat=comprehensive'
}
 
let motorCompreConfig = {
  url: 'https://api-dev.pioneer.com.ph'
}
 
let petConfig = {
  url: '172.21.1.85:3000'
}
 
let ofwConfig = {
  url: 'https://test.pioneer.com.ph/balikmanggagawa'
}
 
let homeConfig = {
  url: 'https://test.pioneer.com.ph/hom.e/'
}
 
let buhayConfig = {
  url: 'https://test.pioneer.com.ph/buhayseries/select-product?agtno=5maVSnYAoK8equal',
  ospital: 'https://test.pioneer.com.ph/buhayseries/select-product?agtno=5maVSnYAoK8equal',
  bahay: 'https://test.pioneer.com.ph/buhayseries/select-product?agtno=5maVSnYAoK8equal',
  aksidente: 'https://test.pioneer.com.ph/buhayseries/select-product?agtno=5maVSnYAoK8equal'
}
 
let sureDayTripConfig = {
  url: 'https://test.pioneer.com.ph/Travel/'
}
 
let defautEmails = {
  pli: "cashier@insureshop.com.ph",
  pisc: "pisccashierlink_insureshop@pioneer.com.ph",
  piic: "piiccashierlink_insureshop@pioneer.com.ph"
}
 
// breadcrumb content
let breadcrumbConfig =  [
  {
    route: '/motor-car-comprehensive',
    stack: [
      {
        name: 'Motor Car and Motorcycle Insurance',
        path: externalAppConfig.motorProducts,
        external: true
      },
      {
        name: 'Motorcar',
        path: externalAppConfig.motorProducts,
        external: true
      },
      {
        name: 'Comprehensive Insurance',
        path: externalAppConfig.motorProducts,
        external: true
      },
      {
        name: 'Learn More',
        path: '',
        external: false
      },
    ]
  }
]
 
export const environment = {
  production: false,
  keycloakConfig: keycloakConfig,
  accihealthConfig: accihealthConfig,
  ctplConfig: ctplConfig,
  motorCompreConfig: motorCompreConfig,
  petConfig: petConfig,
  ofwConfig: ofwConfig,
  homeConfig: homeConfig,
  buhayConfig: buhayConfig,
  sureDayTripConfig: sureDayTripConfig,
  defautEmails: defautEmails,
  idleTimeInMinutes: 1,
  sessionTimeoutInMinutes: 15,
  sessionTimeoutReminderInMinutes: 5,
  otpResendLimit: 5,
  otpCountdownInSeconds: 120,
  issPrefix: defaultISSPrefix,
  externalAppConfig: externalAppConfig,
  breadcrumbConfig: breadcrumbConfig,
  recaptchaSiteKey: RECAPTCHA_SITE_KEY,
  apiToken: TOKEN,
  ctplFaqsFile: ctplDocs
};
 
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.